export default {
  title: {
    en: 'Introducing<br />SAKS x Scentbird<br />collaboration',
  },
  text: {
    en: 'Explore a luxe selection of<br/>over 30 premium scents,<br />created in an exclusive<br />partnership with Saks Fifth<br />Avenue.',
  },
}
